/**
 * Harvesting grass's words (ADR-142 decision 3, P2.26-T3), every one a draft for the author: the prompt's verb, the cast
 * bar's two lines, and the message line for each refusal and break code the map server sends (`refused` and `broken` by
 * code, `unknown` for a code a later server names).
 */
export const HARVEST = {
  action: "Harvest",
  channel: "Harvesting",
  interrupted: "Harvest interrupted",
  refused: {
    tool: "You need a sickle in hand.",
    reach: "That is out of reach.",
    gone: "Someone got there first.",
    full: "Your bag is full.",
    busy: "You are already harvesting.",
    dead: "You can't harvest right now.",
    frozen: "You can't harvest right now.",
    combat: "You can't harvest in a fight.",
    unknown: "You can't harvest that.",
  },
  broken: {
    moved: "Harvest interrupted: you moved.",
    damaged: "Harvest interrupted: you were hit.",
    combat: "Harvest interrupted: a fight began.",
    acted: "Harvest interrupted: you acted.",
    gone: "Someone got there first.",
    full: "Your bag is full.",
    tool: "Harvest interrupted: the sickle left your hand.",
    unknown: "Harvest interrupted.",
  },
} as const;
